module.exports = __webpack_public_path__ + "static/media/krishna.364b203b.png";